module.exports = __webpack_public_path__ + "img/073428.1ce53430.png";